const defaultLatLng = { lat: 15.244722920474269, lng: 104.84749376110715 }
const googleMapsApiKey = "AIzaSyAMD9ipSB_UIMpmMEa9T_3OOdM25P5ADVo"
const locationOptions = {
    enableHighAccuracy: false,
    timeout: 10000,
    maximumAge: 0,
}

export { defaultLatLng , googleMapsApiKey, locationOptions }